import { useNavigate } from "react-router-dom";
import { Flex, Image } from "@mantine/core";
import { ReactComponent as WSPayLogo } from "@/assets/ws-pay/ws-pay-logo.svg";
import MaestroLogo from "@/assets/ws-pay/maestro.gif";
import MasterCardLogo from "@/assets/ws-pay/mastercard.gif";
import VisaLogo from "@/assets/ws-pay/visa.gif";
import VisaSecure from "@/assets/ws-pay/visa-secure.png";
import MastercardIdentityCheck from "@/assets/ws-pay/mastercard-identity-check.png";

interface LinksFooterProps {
  activeTab: string;
}

const LinksFooter: React.FC<LinksFooterProps> = ({ activeTab }) => {
  const navigate = useNavigate();
  const addMarginClass = ["catalogue", "publications"].includes(activeTab);
  return (
    <div
      className={`footer-links items-center ${
        addMarginClass ? "footer-margin-bottom" : ""
      }`}
    >
      <div className="footer-files">
        <div className="footer-link" onClick={() => navigate("/terms")}>
          Opći uvjeti ugovora za kupce
        </div>
        <div className="footer-link" onClick={() => navigate("/privacy")}>
          Pravila zaštite osobnih podataka
        </div>
        <div className="footer-link" onClick={() => navigate("/about-us")}>
          O nama
        </div>
      </div>

      <div className="text-sm">Kontakt: +385 98 919 7815</div>
      <Flex gap={15} wrap="wrap">
        <a
          href="http://www.wspay.info"
          title="Monri WSpay - Web Secure Payment Gateway"
          target="_blank"
        >
          <WSPayLogo height={25} />
        </a>
        <a
          href="https://www.mastercard.com "
          title="MasterCard"
          target="_blank"
        >
          <Image h={25} w="auto" src={MasterCardLogo} />
        </a>
        <a
          href="https://www.mastercard.hr/hr-hr/consumers/find-card-products/debit-cards/maestro-debit.html"
          title="Maestro"
          target="_blank"
        >
          <Image h={25} w="auto" src={MaestroLogo} />
        </a>
        <a href="https://www.visaeurope.com" title="Visa" target="_blank">
          <Image h={25} w="auto" miw="auto" src={VisaLogo} />
        </a>
        <Image h={25} w="auto" src={MastercardIdentityCheck} />
        <Image h={25} w="auto" src={VisaSecure} />
      </Flex>
    </div>
  );
};

export default LinksFooter;
